
import { Moon, Sun } from "lucide-react";
import { useState, useEffect } from "react";

export function ThemeToggle() {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    const isDark = document.documentElement.classList.contains("dark");
    setTheme(isDark ? "dark" : "light");
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    
    if (newTheme === "dark") {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className="relative inline-flex h-8 w-16 items-center rounded-full border-2 border-transparent bg-slate-200 transition-colors hover:bg-slate-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 dark:bg-slate-700 dark:hover:bg-slate-600"
      aria-label="Toggle theme"
    >
      <span
        className={`${
          theme === "dark" ? "translate-x-8" : "translate-x-0"
        } pointer-events-none inline-block h-7 w-7 transform rounded-full bg-white shadow-lg ring-0 transition-transform duration-300 ease-in-out`}
      >
        {theme === "dark" ? (
          <Moon className="h-6 w-6 text-slate-800 m-0.5" strokeWidth={1.5} />
        ) : (
          <Sun className="h-6 w-6 text-amber-500 m-0.5" strokeWidth={1.5} />
        )}
      </span>
    </button>
  );
}
